import { create } from 'zustand';

/**
 * The currently-selected map entity (by track/marker uid) and whether the
 * camera is locked to follow it. Selection drives the selection card, the
 * camera zoom-to, and (for satellites) the coverage footprint.
 */
interface EntitySelectionState {
  /** Uid of the selected marker, or null. */
  selectedUid: string | null;

  /** Whether the camera re-centers on the selected entity as it moves. */
  followMode: boolean;

  /** Select an entity (does not change follow mode). */
  select: (uid: string) => void;

  /** Clear the selection and stop following. */
  clear: () => void;

  /** Toggle follow mode for the current selection. */
  toggleFollow: () => void;
}

/** Store for the selected map entity and follow mode. */
export const useEntitySelectionStore = create<EntitySelectionState>((set) => ({
  selectedUid: null,
  followMode: false,

  select: (uid) => set({ selectedUid: uid }),
  clear: () => set({ selectedUid: null, followMode: false }),
  toggleFollow: () => set((state) => ({ followMode: !state.followMode })),
}));
